import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  modules: { data: [], loading: false },
  priceMatrix: { data: [], loading: false },
  confirm: { name: '', title: '', content: '', active: null, visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
